import Link from "next/link";
import { buttonVariants } from "~/components/ui/button";
import { cn } from "~/lib/utils";
import { ArrowRight } from "lucide-react";

interface PromoContentProps {
  className?: string;
}

export function PromoContent({ className }: PromoContentProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-6 rounded-xl border border-border bg-secondary p-6 text-center",
        className,
      )}
    >
      <h3 className="text-left font-sans text-2xl leading-tight text-foreground">
        Pronađi terapeuta, baš kakav tebi odgovara
      </h3>

      <Link href="/upitnik" className={buttonVariants({ variant: "cta" })}>
        Odgovori na par pitanja
        <ArrowRight className="ml-2 h-4 w-4" />
      </Link>
    </div>
  );
}
